export const FETCH_CONSTANTS = 'constants/FETCH_CONSTANTS'
export const FETCH_CONSTANTS_SUCCESS = 'constants/FETCH_CONSTANTS_SUCCESS'
export const FETCH_CONSTANTS_FAILURE = 'constants/FETCH_CONSTANTS_FAILURE'
export const FETCH_SECURE_CONSTANTS_SUCCESS =
  'constants/FETCH_SECURE_CONSTANTS_SUCCESS'
export const FETCH_SECURE_CONSTANTS_FAILURE =
  'constants/FETCH_SECURE_CONSTANTS_FAILURE'
